import { EmailAddressActionTypes } from "../actions/types";
import { EmailAddressActions } from "../actions/emailaddress.actions";
import { initialState } from "../reducers/root.reducer";

export const emailAddressReducer = (
  state: string = initialState.email,
  action: EmailAddressActions
) => {
  switch (action.type) {
    case EmailAddressActionTypes.ADD_EMAIL_ADDRESS:
      return action.payload;
    default:
      return state;
  }
};
